import {fetchJSON} from '../authService';

class LanguageModel {
    _langList = {};
    _langStore = [];
    _onInitRes = null;
    _onInitRej = null;
    _defaultLang = 'ru';
    initPromise = null;
    /**
     * @param {function} getLangPath - function that recive langName end return all path to langPack
     */
    constructor({ getLangPath, defaultLang = 'ru' }) {
        this._getLangPath = getLangPath;
        this._defaultLang = defaultLang;
        this.initPromise = new Promise((res, rej) => {
            this._onInitRes = res;
            this._onInitRej = rej;
        });
        this._init()
            .then(this._onInitRes)
            .catch(this._onInitRej);

        this.translate.has = this.has;
        this.translate.concat = this.concat;
        this.translate.translate = this.translate;
        this.translate.isRtl = this.isCurrentLanguageRTL;
        this.translate.isCurrentLanguageRTL = this.isCurrentLanguageRTL;
        this.translate.currentLanguageDirection = this.currentLanguageDirection;
    }
    /**
     * Create jssPreset for Material UI styles.
     * Change RTL/LTR according param bool
     * @param {boolean} bool
     * @returns {*|JSS}
     */

    /**
     * init actions to get langList and language pack.
     * set language code to localStorage.
     * @returns {Promise<any>}
     */
    _init = () => (new Promise((resolve, reject) => {
        fetchJSON(this._getLangPath('langList')).then((res) => {
            this._langList = res;
            if (Object.values(this._langList).length > 0) {
                const langName = this.getLocalStorageLanguage() || Object.keys(this._langList)[0];
                fetchJSON(this._getLangPath(langName)).then((lang) => {
                    window.localStorage.setItem('userLang', langName);
                    this._langStore = lang;
                    resolve();
                });
            } else {
                reject({
                    message: 'langList is empty',
                });
            }
        });
    }));

    /**
     * @param {String} key
     * @return {boolean}
     */
    has = (key) => (typeof this._langStore[key] === 'string');

    /**
     *  find key in SelectLanguage Pack and return it value with templateParameters
     * @param {string} key
     * @param  {object} [templateParameters]
     * @example
     * // returns 'Hello Ivan'
     * translate(`Hello {name}`, {name: 'Ivan'});
     * @returns {string}
     */
    translate = (key, templateParameters = null) => {
        let translate;
        if (this._langStore && !Array.isArray(this._langStore) && this._langStore.body[key]) {
            translate = `${this._langStore.body[key]} ${templateParameters ? templateParameters : ''}`;
        } else {
            console.warn(`translate key - "${key}", not found in "${this.getLocalStorageLanguage()}" language package`);
            translate = `#${key}`;
        }
        return translate;
    };

    /**
     * concat strings
     * @param {String[]} stringsArray
     * @param {String} [separator]
     * @return {string}
     */
    concat = (stringsArray, separator = ' ') => {
        const newStringsArray = this.isCurrentLanguageRTL() ? [...stringsArray].reverse() : stringsArray;
        return newStringsArray.join(separator);
    };

    /**
     * Save new langCode in localStorage and reload Page.
     * @param {string} langCode
     */
    changeLanguage = (langCode) => {
        window.localStorage.setItem('userLang', langCode);
        window.location.reload();
    };

    /**
     * Check if LangList contain more then 1 element.
     * @returns {boolean}
     */
    isLanguageChangeable = () => (Object.values(this._langList).length > 1);

    /**
     * return boolen value is Lang Pack RTL
     * @returns {boolean}
     */
    get isRtl() {
        return this._langStore.isRTL;
    }

    /**
     * return boolen value is Lang Pack RTL
     * @returns {boolean}
     */
    isCurrentLanguageRTL = () => (this._langStore.isRTL);

    /**
     * return RTL/LTR string according bool value of Lang Pack RTL
     * @returns {string}
     */
    currentLanguageDirection = () => ((this._langStore.isRTL) ? 'rtl' : 'ltr');

    /**
     * return value of window.localStorage.getItem('lang')
     * @returns {string | null}
     */
    getLocalStorageLanguage = () => (
        window.localStorage.getItem('userLang') || this._defaultLang || 'en'
    );

    /**
     * return LangList object.
     * @returns {Array}
     */
    getLanguages = () => (this._langList);
}

export default LanguageModel;



// WEBPACK FOOTER //
// ./src/helpers/LanguageModel/LanguageModel.js